import { Slider, Typography, Box } from '@material-ui/core'
import React from 'react'

import { getTranslate } from '../../localization'
import useStyles from './styles/index.styles'

export interface AmountRange {
  low: number
  high: number
}

interface AmountSliderProps {
  label?: string
  currency?: string
  min: number
  max: number
  value: AmountRange
  onChange: (newValue: AmountRange) => void
}

const AmountSlider: React.FC<AmountSliderProps> = ({
  label = 'Amount',
  currency = 'IRR',
  min,
  max,
  value,
  onChange
}) => {
  const classes = useStyles()

  const handleChange = (_: any, newValue: number | number[]) => {
    if (Array.isArray(newValue)) {
      onChange({ low: newValue[0], high: newValue[1] })
    }
  }

  return (
    <Box className={classes.root}>
      <Typography variant="h5" className={classes.text}>
        {getTranslate(label)}
      </Typography>
      <Typography variant="h5" className={classes.text} align="right">
        {`${value.low.toLocaleString()} ${currency} - ${value.high.toLocaleString()} ${currency}`}
      </Typography>
      <Slider
        className={classes.slider}
        value={[value.low, value.high]}
        onChange={handleChange}
        valueLabelDisplay="off"
        min={min}
        max={max}
      />
    </Box>
  )
}

export default AmountSlider
